export default {
  'customers.domain.name': 'Nome',
  'customers.domain.cpfCnpj': 'CPF/CNPJ',
  'customers.domain.entryDate': 'Data de Entrada',
  'customers.domain.rg': 'RG',
  'customers.domain.genderType': 'Gênero',
  'customers.domain.sexType': 'Sexo',
  'customers.domain.genderType.man': 'Masculino',
  'customers.domain.genderType.woman': 'Feminino',
  'customers.domain.genderType.genderless': 'Gênero não definido',
  'customers.domain.birthDate': 'Data de Nascimento',
  'customers.domain.maritalStatus': 'Estado Civíl',
  'customers.domain.maritalStatus.single': 'Solteiro',
  'customers.domain.maritalStatus.married': 'Casado',
  'customers.domain.maritalStatus.divorced': 'Divorciado',
  'customers.domain.maritalStatus.widower': 'Viúvo',
  'customers.domain.profession': 'Profissão',
  'customers.domain.nationality': 'Nacionalidade',
  'customers.domain.fantasyName': 'Nome Fantasia',
  'customers.domain.municipalRegistration': 'Inscrição Municipal',
  'customers.domain.stateRegistration': 'Inscrição Estadual',
  'customers.domain.policyNumber': 'Número da Apólice',
  'customers.domain.michelinSegmentCode': 'Código do segmento Michelin',
  'customers.domain.website': 'Site',
  'customers.domain.creditLimit': 'Limite de Crédito',
  'customers.domain.rentalCompany': 'Locadora de Veículo',
  'customers.domain.observation': 'Observação',
  'customers.domain.personType': 'Tipo de Pessoa',
  'customers.domain.personType.natural': 'Pessoa Física',
  'customers.domain.personType.legal': 'Pessoa Jurídica',

  'customers.domain.address.description': 'Descrição',
  'customers.domain.address.street': 'Logradouro',
  'customers.domain.address.number': 'Número',
  'customers.domain.address.zipCode': 'CEP',
  'customers.domain.address.district': 'Distrito',
  'customers.domain.address.complement': 'Complemento',
  'customers.domain.address.main': 'Principal',
  'customers.domain.address.delivery': 'Entrega',

  'customers.domain.contact.contactType': 'Tipo de Contato',
  'customers.domain.contact.contactType.email': 'E-Mail',
  'customers.domain.contact.contactType.mobile': 'Mobile',
  'customers.domain.contact.contactType.fax': 'Fax',
  'customers.domain.contact.contactType.phone': 'Telefone',
  'customers.domain.contact.contactType.whatsapp': 'WhatsApp',
  'customers.domain.contact.name': 'Nome',
  'customers.domain.contact.value': 'Contato',

  'customers.vehicle.accessory': 'Acessórios Automotivos',
  'customer.vehicle.accessory.notifications.create.success.title':
    'Acessório do veículo cadastrado com sucesso!',
  'customer.vehicle.accessory.notifications.update.success.title':
    'Acessório do veículo atualizado com sucesso!',
  'customer.vehicle.accessory.notifications.create.success.description':
    'Novo acessório foi cadastrado com êxito.',
  'customer.vehicle.accessory.accessoryAlreadyExists':
    'Já existe este acessório cadastrado!',
  'customer.vehicle.accessory.error.delete.constraint':
    'Não é possivel excluir um acessório vinculado a um veículo!',

  'customer.vehicle.accessory.notifications.remove.title': 'Remover acessório',
  'customer.vehicle.accessory.notifications.remove.content':
    'Deseja realmente remover o Acessório?',

  'customer.vehicle.accessory.remove.notification.success.message':
    'Acessório Removido',
  'customer.vehicle.accessory.remove.notification.successDescription.description':
    'Acessório foi removido com sucesso!',

  'customers.domain.vehicle.createAccessory':
    'Gerenciar Acessórios Automotivos',
  'customers.domain.vehicle.accessory.description': 'Descrição',

  'customers.domain.vehicle.licensePlate': 'Placa',
  'customers.domain.vehicle.licensePlate.invalidPlateError':
    'Placa inválida. Deve estar nos formatos AAA9999 ou AAA9A99.',
  'customers.domain.vehicle.brand': 'Montadora',
  'customers.domain.vehicle.model': 'Modelo',
  'customers.domain.vehicle.version': 'Versão do Modelo',
  'customers.domain.vehicle.yearFabrication': 'Ano de Fabricação',
  'customers.domain.vehicle.yearModel': 'Ano do Modelo',
  'customers.domain.vehicle.yearModel.invalidError':
    'O ano do modelo deve ser igual ou maior que o ano de fabricação.',
  'customers.domain.vehicle.fuel': 'Combustível',
  'customers.domain.vehicle.fuel.Álcool': 'Álcool',
  'customers.domain.vehicle.fuel.Biodiesel': 'Bio Diesel',
  'customers.domain.vehicle.fuel.Diesel': 'Diesel',
  'customers.domain.vehicle.fuel.Elétrico': 'Elétrico',
  'customers.domain.vehicle.fuel.Flex': 'Flex',
  'customers.domain.vehicle.fuel.Gasolina': 'Gasolina',
  'customers.domain.vehicle.fuel.GNV/Álcool': 'GNV/Álcool',
  'customers.domain.vehicle.fuel.GNV/Flex': 'GNV/Flex',
  'customers.domain.vehicle.fuel.GNV/Gasolina': 'GNV/Gasolina',
  'customers.domain.vehicle.fuel.Híbrido': 'Híbrido',
  'customers.domain.vehicle.km': 'Km média/mês',
  'customers.domain.vehicle.renavam': 'Renavam',
  'customers.domain.vehicle.chassi': 'Chassi',
  'customers.domain.vehicle.color': 'Cor',
  'customers.domain.vehicle.color.beige': 'Bege',
  'customers.domain.vehicle.color.black': 'Preta',
  'customers.domain.vehicle.color.blue': 'Azul',
  'customers.domain.vehicle.color.brown': 'Marrom',
  'customers.domain.vehicle.color.gold': 'Dourada',
  'customers.domain.vehicle.color.gray': 'Cinza',
  'customers.domain.vehicle.color.green': 'Verde',
  'customers.domain.vehicle.color.orange': 'Laranja',
  'customers.domain.vehicle.color.pink': 'Rosa',
  'customers.domain.vehicle.color.purple': 'Roxa',
  'customers.domain.vehicle.color.red': 'Vermelha',
  'customers.domain.vehicle.color.silver': 'Prata',
  'customers.domain.vehicle.color.white': 'Branca',
  'customers.domain.vehicle.color.yellow': 'Amarelo',
  'customers.domain.vehicle.color.grena': 'Grená',
  'customers.domain.vehicle.color.undefined': 'Indefinida',
  'customers.domain.vehicle.color.fantasy': 'Fantasia',

  'customers.domain.vehicle.accessories': 'Acessórios',

  'customers.modal.report.title': 'Gerar Relatório',
  'customers.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'customers.modal.report.buttons.pdf': 'Gerar PDF',
  'customers.modal.report.buttons.rtf': 'Gerar RTF',
  'customers.modal.report.buttons.csv': 'Gerar CSV',
  'customers.modal.report.form.type': 'Tipo',
  'customers.modal.report.form.situation': 'Situação',
  'customers.modal.report.form.state': 'UF',
  'customers.modal.report.form.city': 'Cidade',
  'customers.modal.report.form.birthdayOf': 'Aniversário De, Até',
  'customers.modal.report.form.inclusionData': 'Data de inclusão De, Até',
  'customers.modal.report.form.sex': 'Sexo',
  'customers.modal.report.form.vehicleBrand': 'Marca',
  'customers.modal.report.form.vehicleModel': 'Modelo',
  'customers.notification.generate.report.title':
    'Relatório gerado com sucesso',
  'customers.notification.generate.report.description':
    'Relatório de Cliente Gerado com Sucesso!',

  'customers.generalInfo': 'Dados Gerais',

  'customers.address': 'Endereço',
  'customers.address.create.notification.success': 'Sucesso',
  'customers.address.create.notification.successDescription':
    'Endereço criado.',

  'customers.address.update.notification.success': 'Sucesso',
  'customers.address.update.notification.successDescription':
    'Endereço atualizado.',

  'customers.address.remove': 'Remover Endereço',
  'customers.address.remove.alert': 'Você realmente deseja remover o endereço?',
  'customers.address.remove.notification.success': 'Sucesso',
  'customers.address.remove.notification.successDescription':
    'Endereço removido.',

  'customers.contact': 'Contato',
  'customers.contact.create.notification.success': 'Sucesso',
  'customers.contact.create.notification.successDescription': 'Contato criado.',

  'customers.contact.update.notification.success': 'Sucesso',
  'customers.contact.update.notification.successDescription':
    'Contato atualizado.',

  'customers.contact.remove': 'Remover Contato',
  'customers.contact.remove.alert': 'Você realmente deseja remover o contato:',
  'customers.contact.remove.notification.success': 'Sucesso',
  'customers.contact.remove.notification.successDescription':
    'Contato removido.',

  'customers.domain.vehicle.create': 'Novo Veículo',
  'customers.vehicle': 'Veículo',
  'customers.vehicle.create.notification.success': 'Sucesso',
  'customers.vehicle.create.notification.successDescription': 'Veículo criado.',

  'customers.vehicle.update.notification.success': 'Sucesso',
  'customers.vehicle.update.notification.successDescription':
    'Veículo atualizado.',

  'customers.vehicle.remove': 'Remover Veículo',
  'customers.vehicle.remove.confirm.title': 'Remover Veículo',
  'customers.vehicle.remove.confirm.content':
    'Você realmente deseja remover o veículo:',
  'customers.vehicle.remove.success.message': 'Sucesso',
  'customers.vehicle.remove.success.description': 'Veículo removido.',

  'customers.simplifiedRegister': 'Registro Simplificado de Cliente',

  'customers.vehicle.simplifiedRegister': 'Registro Simplificado de Veículo',

  'customers.list.newCustomer': 'Criar Novo Cliente',
  'customers.list.header.name': 'Nome',
  'customers.list.header.fantasyName': 'Nome Fantasia',
  'customers.list.header.cpfCnpj': 'CPF/CNPJ',
  'customers.list.header.email': 'E-Mail',
  'customers.list.header.phone': 'Telefone',
  'customers.list.header.numberPlate': 'Placa',
  'customers.list.header.includedAt': 'Inclusão',
  'customers.list.header.actions': 'Ações',
  'customers.list.header.actions.button': 'Ver/Editar',
  'customers.details.generalInfo.form.individual': 'Pessoa Física',
  'customers.details.generalInfo.form.corporation': 'Pessoa Jurídica',
  'customers.details.generalInfo.form.name': 'Nome do cliente',
  'customers.details.generalInfo.form.cpfCnpj': 'CPF/CNPJ',
  'customers.details.generalInfo.form.rg': 'RG',
  'customers.details.generalInfo.form.gender': 'Sexo',
  'customers.details.generalInfo.form.maritalStatus': 'Estado civil',
  'customers.details.generalInfo.form.nationality': 'Nacionalidade',
  'customers.details.generalInfo.form.fantasyName': 'Nome fantasia',
  'customers.details.generalInfo.form.municipalRegistration':
    'Inscrição municipal',
  'customers.details.generalInfo.form.stateRegistration': 'Inscrição estadual',
  'customers.details.generalInfo.form.website': 'Site',
  'customers.details.generalInfo.form.creditLimit': 'Limite de crédito',
  'customers.details.generalInfo.form.birthDate': 'Nascimento',
  'customers.details.generalInfo.form.email': 'E-Mail',
  'customers.details.generalInfo.form.phone1': 'Telefone 1',
  'customers.details.generalInfo.form.phone2': 'Telefone 2',
  'customers.details.generalInfo.form.profession': 'Profissão',
  'customers.details.generalInfo.form.meetingMethod': 'Como nos conheceu?',
  'customers.details.generalInfo.form.billingAddress': 'Endereço',
  'customers.details.generalInfo.form.cep': 'CEP',
  'customers.details.generalInfo.form.street': 'Logradouro',
  'customers.details.generalInfo.form.number': 'Número',
  'customers.details.generalInfo.form.complement': 'Complemento',
  'customers.details.generalInfo.form.district': 'Bairro',
  'customers.details.generalInfo.form.city': 'Cidade',
  'customers.details.generalInfo.form.state': 'Estado',
  'customers.details.generalInfo.form.addAddress': 'Adicionar Endereço',
  'customers.details.generalInfo.form.obs': 'Observações',
  'customers.details.generalInfo.form.rentalCompany': 'Locadora de veículo?',
  'customers.details.generalInfo.form.genderType.man': 'Masculino',
  'customers.details.generalInfo.form.genderType.woman': 'Feminino',
  'customers.details.generalInfo.form.maritalStatus.single': 'Solteiro',
  'customers.details.generalInfo.form.maritalStatus.married': 'Casado',
  'customers.details.generalInfo.form.maritalStatus.divorced': 'Divorciado',
  'customers.details.generalInfo.form.maritalStatus.widower': 'Viúvo',
  'customers.details.generalInfo.form.publicAgency': 'Orgão público',
  'customers.details.generalInfo.form.issRetention':
    'Haverá retenção de ISS para este cliente?',
  'customers.details.generalInfo.form.irpjOrCsllRetention':
    'Haverá retenção de IRRF/CSLL para este cliente?',
  'customers.details.generalInfo.form.enableLgpd':
    'Autoriza uso de dados (LGPD)?',
  'customers.details.generalInfo.form.enableAlert':
    'Não mostrar alerta sobre termo LGPD ao editar ou salvar orçamento?',
  'customers.details.generalInfo.form.crm':
    'CRM - Relacionamento com o Cliente',
  'customers.details.generalInfo.form.whatsapp': 'WhatsApp',
  'customers.details.generalInfo.form.sms': 'SMS',
  'customers.filters.active.options.all': 'Todos',
  'customers.filters.active': 'Ativo',
  'customers.filters.active.options.all': 'Todos',
  'customers.filters.active.options.active': 'Ativo',
  'customers.filters.active.options.inactive': 'Inativo',
  'customers.filters.cpfCnpj': 'CPF/CNPJ',
  'customers.filters.fantasyName': 'Nome fantasia',
  'customers.filters.genderType': 'Gênero',
  'customers.filters.genderType.options.man': 'Masculino',
  'customers.filters.genderType.options.woman': 'Feminino',
  'customers.filters.licensePlate': 'Placa',
  'customers.filters.personType': 'Tipo de pessoa',
  'customers.filters.personType.options.natural': 'Física',
  'customers.filters.personType.options.legal': 'Jurídica',
  'customers.filters.order': 'Ordenar por',
  'customers.filters.order.options.asc': 'Ascendente',
  'customers.filters.order.options.desc': 'Descendente',

  'customers.notifications.create.success.title':
    'Cliente cadastrado com sucesso!',
  'customers.notifications.create.success.description':
    'O novo cliente foi cadastrado com êxito.',

  'customer.status.message': 'Status do cliente alterado com sucesso!',

  'customers.notifications.create.error.title': 'Erro ao cadastrar o cliente!',
  'customers.notifications.create.error.description':
    'Ocorreu um erro ao cadastrar os clientes. Verifique os campos e tente novamente.',

  'customers.notifications.update.success.title':
    'Cliente atualizado com sucesso!',
  'customers.notifications.update.success.description':
    'As informações do cliente foram atualizadas com sucesso.',

  'customers.notifications.update.error.title': 'Erro ao atualizar o cliente!',
  'customers.notifications.update.error.description':
    'Ocorreu um erro ao atualizar o cliente. Verifique os campos e tente novamente.',

  'customers.notifications.remove.success.title':
    'Cliente removido com sucesso!',
  'customers.notifications.remove.success.description':
    'O cliente foi removido com sucesso do sistema.',

  'customers.notifications.remove.error.title': 'Erro ao remover o cliente!',
  'customers.notifications.remove.error.description':
    'Ocorreu um erro ao tentar remover o cliente.',

  'customers.notifications.remove.confirm.title':
    'Você deseja realmente excluir esse cliente?',
  'customers.notifications.remove.confirm.content':
    'Ao remover o cliente, todas as suas informações serão perdidas permanentemente. Ainda sim deseja continuar?',
  'customers.notifications.remove.confirm.okText': 'Remover cliente',
  'customers.notifications.remove.confirm.cancelText': 'Cancelar',

  'customers.modal.selectedCustomers.title.add': 'Adicionar Cliente',
  'customers.modal.selectedCustomers.search': 'Busque os clientes',

  'customers.form.button.recommendation.create': 'Criar',
  'customers.list.recommendation': 'Indicação',
  'customers.form.recommendation': 'Como nos conheceu?',
  'customers.form.recommendation.description': 'Descrição',
  'customers.form.recommendation.create.success':
    'Recomendação criada com sucesso!',
  'customers.form.recommendation.update.success':
    'Recomendação editada com sucesso!',
  'customers.recommendation.notifications.remove.confirm.title':
    'Você deseja realmente excluir essa indicação?',
  'customers.recommendation.notifications.remove.confirm.content':
    'Ao remover a indicação, a indicação será deletada permanentemente. Ainda sim deseja continuar?',
  'customers.form.recommendation.delete.success':
    'Recomendação excluída com sucesso!',
  'customers.form.button.recommendation.update.modal.title':
    'Editar Recomendação',
  'customers.form.recommendation.create.error.duplicate.description':
    'Recomendação já criada com essa descrição.',
  'customer.recommendation.error.delete.constraint':
    'Não é possivel excluir uma recomendação que tenha vínculo',
};
